import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isPartnerAdmin } from "../../admin/navigation/adminNavigation";

const PartnerProtected = ({ children }) => {
  const authState = useSelector((state) => state.auth);
  const location = useLocation();

  if (isPartnerAdmin(authState)) {
    return children;
  }

  return (
    <Navigate
      to="/admin-login"
      replace
      state={{ from: `${location.pathname}${location.search}${location.hash}` }}
    />
  );
};

export default PartnerProtected;
